// Adds validation traits to a child component
export default {
	props: {
		// REQUIRED if there are multiple fields with the same label, otherwise an infinite loop may be encountered
		validationLabel: String,

		required: {
			type: Boolean,
			default: true,
		},

		immediate: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		// Used for identifying the field in errors array - MUST BE UNIQUE (an infinite loop might happen if it isn't)
		// By default label will be used, otherwise you can optionally specify a validation label
		idLabel() {
			return this.validationLabel || this.label;
		},
	},
};
